const roles = [
    "Sewadar",
    "Deputy Incharge",
    "Incharge"
]


export default roles
